import { FORMS_DEFAULT_REQUIRED_FIELD_ERROR, STROLLER_QUESTION_PLACEHOLDER } from 'mk/autogenerated/translations/QuestionAddForm.65fb37c1f87a538e49f49cb1f8c9444c'
import { TextareaField } from 'mk2/components/forms/TextareaField';
import { Form } from 'mk2/components/Form';
import { ComposeToolbar, FIXED } from 'mk2/containers/Toolbar/Toolbar';
import { mkReduxForm, MKReduxFormInjectedProps } from 'mk2/decorators/mkReduxForm';
import React from 'react';
import { FormErrors } from 'redux-form';
import styles from './QuestionAddForm.mscss';

export const STROLLER_ADD_QUESTION_FORM_NAME = 'STROLLER_ADD_QUESTION_FORM_NAME';

export interface QuestionAddFormData {
    question: string;
}

const validate = (values: QuestionAddFormData): FormErrors<QuestionAddFormData> => {
    const errors: FormErrors<QuestionAddFormData> = {};
    if (!values.question) {
        errors.question = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
    }

    return errors;
};

interface OwnProps {
    slug: string;
    initialValues: QuestionAddFormData;
    isMobile: boolean;

    onSave(slug: string, values: QuestionAddFormData);
}

type Props = OwnProps;

class QuestionAddFormComponent extends React.Component<Props & MKReduxFormInjectedProps<QuestionAddFormData, Props>> {

    private emojisConfig = {
        fields: ['question'],
        defaultField: 'question',
    };

    public render() {
        const { isMobile, handleSubmit } = this.props;

        return (
            <Form className={styles.QuestionAddForm} onSubmit={handleSubmit}>
                <TextareaField
                    name="question"
                    label={STROLLER_QUESTION_PLACEHOLDER}
                    rows={isMobile ? 10 : 25}
                    bottomBorder={false}
                    fillRemainingSpace
                />

                {!isMobile && (
                    // bez fotiek a stickerov, tak na mobile nema zmysel zobrazovat
                    <ComposeToolbar
                        formName={STROLLER_ADD_QUESTION_FORM_NAME}
                        isFixed={FIXED.IF_MOBILE_BUT_IOS}
                        emojis={this.emojisConfig}
                        stickers={false}
                    />
                )}
            </Form>
        );
    }
}

export const QuestionAddForm = mkReduxForm<QuestionAddFormData, Props>({
    formName: STROLLER_ADD_QUESTION_FORM_NAME,
    onValidate: validate,
    onSave: (values, props) => props.onSave(props.slug, values),
})(QuestionAddFormComponent);
